import { useRouterState, type AnyRouter } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const NAVIGATION_PROGRESS_DELAY_MS = 120;

/**
 * The previous page stays on screen until the next one has loaded, so a click
 * needs its own acknowledgement. Revalidating the current URL stays silent.
 */
export function NavigationProgress() {
  // History keys distinguish a repeat visit to the same URL from this one.
  const pending = useRouterState<AnyRouter, string | null>({
    select: (state) =>
      state.status === "pending" &&
      state.location.href !== (state.resolvedLocation?.href ?? state.location.href)
        ? `${state.location.state.__TSR_key ?? ""}:${state.location.href}`
        : null,
  });
  const [revealed, setRevealed] = useState<string | null>(null);

  useEffect(() => {
    if (!pending) return;
    const timer = window.setTimeout(
      () => setRevealed(pending),
      NAVIGATION_PROGRESS_DELAY_MS,
    );
    return () => window.clearTimeout(timer);
  }, [pending]);

  if (!pending || revealed !== pending) return null;
  return <div role="progressbar" aria-label="Loading page" className="navigation-progress" />;
}
